var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import kfetch from '@kareo/kfetch';
import { AccessLevels, authenticatedUser, PrivilegeTypes, Roles, } from '../../../lib/sdk/authenticatedUser';
import { User } from '../../service/accessControl/types';
export var getUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kfetch("/common-ui/api/User/me", {
                method: 'GET',
            }).catch(function (error) {
                var _a;
                throw new Error(((_a = error === null || error === void 0 ? void 0 : error.body) === null || _a === void 0 ? void 0 : _a.message) ||
                    'facesheet accessControl service - error getting user');
            })];
    });
}); };
export var getUserPermissions = function () {
    return kfetch("/access-control-ui/api/users/permissions")
        .then(function (response) { return new User(response); })
        .catch(function (error) {
        var _a;
        throw new Error(((_a = error === null || error === void 0 ? void 0 : error.body) === null || _a === void 0 ? void 0 : _a.message) ||
            'facesheet accessControl service - error getting user permissions');
    });
};
// Using fetch for access to full response with headers and status code for resilience caching
export var getUserChartAccess = function (patientId) {
    return fetch("/facesheet-ui/api/Facesheet/access/restrictions/patient/" + patientId);
};
// Using fetch for access to full response with headers and status code for resilience caching
export var getAllUsersWithChartAccess = function (patientId) {
    return fetch("/facesheet-ui/api/Facesheet/access/users/patient/" + patientId);
};
export var fetchUserPermissions = function () { return __awaiter(void 0, void 0, void 0, function () {
    var hasChartPrivilege, hasChartWritePrivilege, hasLabsPrivilege, hasNotesPrivilege, hasCareChecklistPrivilege, hasFlowsheetsPrivilege, modalRolePath, isPPCEnabled, isValidModalRole, careChecklistPrivilegeId, privileges, isSysAdmin, isOfficeStaff, isAdminOffice, isProvider, isClin, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                hasChartPrivilege = false;
                hasChartWritePrivilege = false;
                hasLabsPrivilege = false;
                hasNotesPrivilege = false;
                hasCareChecklistPrivilege = false;
                hasFlowsheetsPrivilege = false;
                modalRolePath = '';
                isPPCEnabled = true;
                isValidModalRole = false;
                careChecklistPrivilegeId = 47;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 8]);
                return [4 /*yield*/, authenticatedUser.getPrivileges()];
            case 2:
                privileges = _b.sent();
                hasChartPrivilege = privileges.some(function (privilege) {
                    return privilege.id === PrivilegeTypes.Patient_Chart &&
                        privilege.accessType >= AccessLevels.Read;
                });
                hasChartWritePrivilege = privileges.some(function (privilege) {
                    return privilege.id === PrivilegeTypes.Patient_Chart &&
                        privilege.accessType === AccessLevels.Write;
                });
                hasLabsPrivilege = privileges.some(function (privilege) {
                    return privilege.id === PrivilegeTypes.Labs_View &&
                        privilege.accessType >= AccessLevels.Read;
                });
                hasNotesPrivilege = privileges.some(function (privilege) {
                    return privilege.id === PrivilegeTypes.Notes &&
                        privilege.accessType === AccessLevels.Write;
                });
                hasCareChecklistPrivilege = privileges.some(function (privilege) {
                    return privilege.id === careChecklistPrivilegeId &&
                        privilege.accessType === AccessLevels.Write;
                });
                return [4 /*yield*/, authenticatedUser.hasRole(Roles.SystemAdministrator)];
            case 3:
                isSysAdmin = _b.sent();
                return [4 /*yield*/, authenticatedUser.hasRole(Roles.OfficeStaff)];
            case 4:
                isOfficeStaff = _b.sent();
                isAdminOffice = isSysAdmin || isOfficeStaff;
                return [4 /*yield*/, authenticatedUser.hasRole(Roles.Provider)];
            case 5:
                isProvider = _b.sent();
                return [4 /*yield*/, authenticatedUser.hasRole(Roles.ClinicalAssistant)];
            case 6:
                isClin = _b.sent();
                // Only check permissions if not a biller
                isValidModalRole = isAdminOffice || isProvider || isClin;
                modalRolePath = 'CLIN';
                if (isAdminOffice) {
                    modalRolePath = 'ADMIN';
                }
                else if (isProvider) {
                    modalRolePath = 'PROVIDER';
                }
                hasFlowsheetsPrivilege = isProvider || isClin;
                return [3 /*break*/, 8];
            case 7:
                error_1 = _b.sent();
                throw new Error(((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.body) === null || _a === void 0 ? void 0 : _a.message) ||
                    'facesheet accessControl service - fetchUserPermissions error');
            case 8: return [2 /*return*/, {
                    protectionSettings: {
                        isPPCEnabled: isPPCEnabled,
                        modalRolePath: modalRolePath,
                        isValidModalRole: isValidModalRole,
                    },
                    userPrivileges: {
                        hasChartPrivilege: hasChartPrivilege,
                        hasChartWritePrivilege: hasChartWritePrivilege,
                        hasNotesPrivilege: hasNotesPrivilege,
                        hasLabsPrivilege: hasLabsPrivilege,
                        hasCareChecklistPrivilege: hasCareChecklistPrivilege,
                        hasFlowsheetsPrivilege: hasFlowsheetsPrivilege,
                    },
                }];
        }
    });
}); };
export var getChartNavbarConfigurationForUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kfetch("/facesheet-ui/api/Facesheet/views")];
    });
}); };
